import React, { useState } from "react";
import DashboardLayout from "../Layout/DashboardLayout";
import Breadcrumbs from "../Components/Dashboard/Breadcrumbs";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import AdminTable from "../Components/AdminTable";
import AddNewUserSuccess from "../Components/AddNewUserSuccess";
import AddNewUserModal from "../Components/AddNewUserModal";
import AddNewCorpUserModal from "../Components/AddNewCorpUserModal";

const chartOneData = [
  {
    name: "Team 1",
    "Number of Weeks": 25,
  },
  {
    name: "Team 2",
    "Number of Weeks": 35,
  },
  {
    name: "Team 3",
    "Number of Weeks": 45,
  },
  {
    name: "Team 4",
    "Number of Weeks": 23,
  },
  {
    name: "Team 5",
    "Number of Weeks": 45,
  },
  {
    name: "Team 6",
    "Number of Weeks": 20,
  },
  {
    name: "Team 7",
    "Number of Weeks": 26,
  },
];

const chartTwoData = [
  {
    name: "Team 1",
    Workload: 80,
    design: 233,
  },
  {
    name: "Team 2",
    Workload: 100,
    design: 200,
  },
  {
    name: "Team 3",
    Workload: 50,
    design: 254,
  },
  {
    name: "Team 4",
    Workload: 70,
    design: 275,
  },
  {
    name: "Team 5",
    Workload: 82,
    design: 285,
  },
  {
    name: "Team 6",
    Workload: 80,
    design: 275,
  },
];

const SuperAdmin = () => {
  const [openNewCorpUserModal, setOpenNewCorpUserModal] = useState(false);
  const [openNewUserModal, setOpenNewUserModal] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  return (
    <DashboardLayout>
      <section className="px-6 pt-4 w-full bg-[#f9fafb]">
        <AddNewUserModal
          open={openNewUserModal}
          setOpen={setOpenNewUserModal}
          setOpenSuccess={setOpenSuccess}
        />
        <AddNewCorpUserModal
          open={openNewCorpUserModal}
          setOpen={setOpenNewCorpUserModal}
        />
        <AddNewUserSuccess open={openSuccess} setOpen={setOpenSuccess} />
        <Breadcrumbs links={[{ name: "Admin", link: "/" }]} />
        <div className="flex items-center justify-between w-full mt-6">
          <div className="flex flex-col gap-y-1">
            <span className="text-2xl font-bold text-[#111928]">
              Welcome, John Doe
            </span>
            <span className="text-md text-[#6B7280]">
              Your current Statistics summary and activity.
            </span>
          </div>
          <div>
            <div className="flex items-stretch">
              <button className="border py-1.5 px-4 rounded-l-lg text-sm font-medium bg-[#f9fafb] text-[#6B7280]">
                This Year
              </button>
              <button className="border py-1.5 px-4 rounded-r-lg text-sm font-medium text-[#6B7280] bg-white">
                This Month
              </button>
            </div>
          </div>
        </div>
        <div className="flex items-stretch justify-between w-full mt-3">
          <span className="flex items-center bg-white py-2 px-4 rounded-lg mt-2 border">
            <svg
              width={20}
              height={21}
              viewBox="0 0 20 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.5 8.83342H2.5M13.3333 2.16675V5.50008M6.66667 2.16675V5.50008M6.5 18.8334H13.5C14.9001 18.8334 15.6002 18.8334 16.135 18.5609C16.6054 18.3212 16.9878 17.9388 17.2275 17.4684C17.5 16.9336 17.5 16.2335 17.5 14.8334V7.83342C17.5 6.43328 17.5 5.73322 17.2275 5.19844C16.9878 4.72803 16.6054 4.34558 16.135 4.1059C15.6002 3.83341 14.9001 3.83341 13.5 3.83341H6.5C5.09987 3.83341 4.3998 3.83341 3.86502 4.1059C3.39462 4.34558 3.01217 4.72803 2.77248 5.19844C2.5 5.73322 2.5 6.43328 2.5 7.83341V14.8334C2.5 16.2335 2.5 16.9336 2.77248 17.4684C3.01217 17.9388 3.39462 18.3212 3.86502 18.5609C4.3998 18.8334 5.09987 18.8334 6.5 18.8334Z"
                stroke="#344054"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-medium ml-1">Select dates</p>
          </span>
          <span className="flex items-center justify-between max-w-[20rem] bg-white py-2 px-4 rounded-lg mt-2 border">
            <p className="text-xs font-medium">Demographics</p>
            <svg
              width={18}
              height={19}
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-2"
            >
              <path
                d="M14.25 7.25L9 12.5L3.75 7.25"
                stroke="#111928"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="flex items-center justify-between max-w-[20rem] bg-white py-2 px-4 rounded-lg mt-2 border">
            <p className="text-xs font-medium">Filter By</p>
            <svg
              width={18}
              height={19}
              viewBox="0 0 18 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="ml-2"
            >
              <path
                d="M14.25 7.25L9 12.5L3.75 7.25"
                stroke="#111928"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
          <span className="flex items-center bg-white py-2 px-4 rounded-lg mt-2 border">
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.41421 9.91421C9.78929 9.53914 10 9.03043 10 8.5C10 7.96957 9.78929 7.46086 9.41421 7.08579C9.03914 6.71071 8.53043 6.5 8 6.5C7.46957 6.5 6.96086 6.71071 6.58579 7.08579C6.21071 7.46086 6 7.96957 6 8.5C6 9.03043 6.21071 9.53914 6.58579 9.91421C6.96086 10.2893 7.46957 10.5 8 10.5C8.53043 10.5 9.03914 10.2893 9.41421 9.91421Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M1.63672 8.49992C2.48605 5.79525 5.01338 3.83325 7.99805 3.83325C10.9834 3.83325 13.5101 5.79525 14.3594 8.49992C13.5101 11.2046 10.9834 13.1666 7.99805 13.1666C5.01338 13.1666 2.48605 11.2046 1.63672 8.49992Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-medium ml-1">View Al Projects</p>
          </span>
          <span className="flex items-center bg-white py-2 px-4 rounded-lg mt-2 border">
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.11667 3.378C8.83267 2.20733 7.16733 2.20733 6.88333 3.378C6.69933 4.13467 5.83267 4.49333 5.16867 4.088C4.13933 3.46133 2.962 4.63933 3.58867 5.668C3.68287 5.8225 3.73926 5.99706 3.75325 6.17748C3.76723 6.35789 3.73843 6.53906 3.66916 6.70623C3.5999 6.87341 3.49215 7.02187 3.35467 7.13953C3.21719 7.25719 3.05387 7.34072 2.878 7.38333C1.70733 7.66733 1.70733 9.33267 2.878 9.61667C3.05371 9.6594 3.21686 9.74298 3.35418 9.86063C3.49151 9.97828 3.59913 10.1267 3.66831 10.2937C3.7375 10.4608 3.76628 10.6419 3.75232 10.8222C3.73837 11.0024 3.68207 11.1769 3.588 11.3313C2.96133 12.3607 4.13933 13.538 5.168 12.9113C5.3225 12.8171 5.49706 12.7607 5.67748 12.7468C5.85789 12.7328 6.03906 12.7616 6.20623 12.8308C6.37341 12.9001 6.52187 13.0079 6.63953 13.1453C6.75719 13.2828 6.84072 13.4461 6.88333 13.622C7.16733 14.7927 8.83267 14.7927 9.11667 13.622C9.1594 13.4463 9.24298 13.2831 9.36063 13.1458C9.47828 13.0085 9.62667 12.9009 9.79375 12.8317C9.96082 12.7625 10.1419 12.7337 10.3222 12.7477C10.5024 12.7616 10.6769 12.8179 10.8313 12.912C11.8607 13.5387 13.038 12.3607 12.4113 11.332C12.3171 11.1775 12.2607 11.0029 12.2468 10.8225C12.2328 10.6421 12.2616 10.4609 12.3308 10.2938C12.4001 10.1266 12.5079 9.97813 12.6453 9.86047C12.7828 9.74281 12.9461 9.65928 13.122 9.61667C14.2927 9.33267 14.2927 7.66733 13.122 7.38333C12.9463 7.3406 12.7831 7.25702 12.6458 7.13937C12.5085 7.02172 12.4009 6.87333 12.3317 6.70625C12.2625 6.53918 12.2337 6.35814 12.2477 6.17785C12.2616 5.99756 12.3179 5.8231 12.412 5.66867C13.0387 4.63933 11.8607 3.462 10.832 4.08867C10.6775 4.18287 10.5029 4.23926 10.3225 4.25325C10.1421 4.26723 9.96094 4.23843 9.79377 4.16916C9.62659 4.0999 9.47813 3.99215 9.36047 3.85467C9.24281 3.71719 9.15928 3.55387 9.11667 3.378Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.41421 9.91421C9.78929 9.53914 10 9.03043 10 8.5C10 7.96957 9.78929 7.46086 9.41421 7.08579C9.03914 6.71071 8.53043 6.5 8 6.5C7.46957 6.5 6.96086 6.71071 6.58579 7.08579C6.21071 7.46086 6 7.96957 6 8.5C6 9.03043 6.21071 9.53914 6.58579 9.91421C6.96086 10.2893 7.46957 10.5 8 10.5C8.53043 10.5 9.03914 10.2893 9.41421 9.91421Z"
                stroke="#111928"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p className="text-xs font-medium ml-1">
              Manage Generative AI Index
            </p>
          </span>
          <span
            className="flex items-center bg-[#942A27] py-2 px-4 rounded-lg mt-2 cursor-pointer"
            onClick={() => setOpenNewCorpUserModal(true)}
          >
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4.5C8.21217 4.5 8.41566 4.58429 8.56569 4.73431C8.71571 4.88434 8.8 5.08783 8.8 5.3V7.7H11.2C11.4122 7.7 11.6157 7.78429 11.7657 7.93431C11.9157 8.08434 12 8.28783 12 8.5C12 8.71217 11.9157 8.91566 11.7657 9.06569C11.6157 9.21571 11.4122 9.3 11.2 9.3H8.8V11.7C8.8 11.9122 8.71571 12.1157 8.56569 12.2657C8.41566 12.4157 8.21217 12.5 8 12.5C7.78783 12.5 7.58434 12.4157 7.43431 12.2657C7.28429 12.1157 7.2 11.9122 7.2 11.7V9.3H4.8C4.58783 9.3 4.38434 9.21571 4.23431 9.06569C4.08429 8.91566 4 8.71217 4 8.5C4 8.28783 4.08429 8.08434 4.23431 7.93431C4.38434 7.78429 4.58783 7.7 4.8 7.7H7.2V5.3C7.2 5.08783 7.28429 4.88434 7.43431 4.73431C7.58434 4.58429 7.78783 4.5 8 4.5V4.5Z"
                fill="white"
              />
            </svg>
            <p className="text-xs text-white font-medium ml-1">
              Add corporate user
            </p>
          </span>
          <span className="flex items-center bg-[#942A27] py-2 px-4 rounded-lg mt-2">
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4.5C8.21217 4.5 8.41566 4.58429 8.56569 4.73431C8.71571 4.88434 8.8 5.08783 8.8 5.3V7.7H11.2C11.4122 7.7 11.6157 7.78429 11.7657 7.93431C11.9157 8.08434 12 8.28783 12 8.5C12 8.71217 11.9157 8.91566 11.7657 9.06569C11.6157 9.21571 11.4122 9.3 11.2 9.3H8.8V11.7C8.8 11.9122 8.71571 12.1157 8.56569 12.2657C8.41566 12.4157 8.21217 12.5 8 12.5C7.78783 12.5 7.58434 12.4157 7.43431 12.2657C7.28429 12.1157 7.2 11.9122 7.2 11.7V9.3H4.8C4.58783 9.3 4.38434 9.21571 4.23431 9.06569C4.08429 8.91566 4 8.71217 4 8.5C4 8.28783 4.08429 8.08434 4.23431 7.93431C4.38434 7.78429 4.58783 7.7 4.8 7.7H7.2V5.3C7.2 5.08783 7.28429 4.88434 7.43431 4.73431C7.58434 4.58429 7.78783 4.5 8 4.5V4.5Z"
                fill="white"
              />
            </svg>
            <p className="text-xs text-white font-medium ml-1">
              Assign AI team
            </p>
          </span>
          <span
            className="flex items-center bg-[#942A27] py-2 px-4 rounded-lg mt-2 cursor-pointer"
            onClick={() => setOpenNewUserModal(true)}
          >
            <svg
              width={16}
              height={17}
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 4.5C8.21217 4.5 8.41566 4.58429 8.56569 4.73431C8.71571 4.88434 8.8 5.08783 8.8 5.3V7.7H11.2C11.4122 7.7 11.6157 7.78429 11.7657 7.93431C11.9157 8.08434 12 8.28783 12 8.5C12 8.71217 11.9157 8.91566 11.7657 9.06569C11.6157 9.21571 11.4122 9.3 11.2 9.3H8.8V11.7C8.8 11.9122 8.71571 12.1157 8.56569 12.2657C8.41566 12.4157 8.21217 12.5 8 12.5C7.78783 12.5 7.58434 12.4157 7.43431 12.2657C7.28429 12.1157 7.2 11.9122 7.2 11.7V9.3H4.8C4.58783 9.3 4.38434 9.21571 4.23431 9.06569C4.08429 8.91566 4 8.71217 4 8.5C4 8.28783 4.08429 8.08434 4.23431 7.93431C4.38434 7.78429 4.58783 7.7 4.8 7.7H7.2V5.3C7.2 5.08783 7.28429 4.88434 7.43431 4.73431C7.58434 4.58429 7.78783 4.5 8 4.5V4.5Z"
                fill="white"
              />
            </svg>
            <p className="text-xs text-white font-medium ml-1">Add New User</p>
          </span>
        </div>

        <main className="mt-6">
          <div>
            <span className="text-[#6B7280] text-md">Demographics</span>
            <div className="grid grid-cols-4 gap-x-3 mt-3">
              <div className="flex items-center justify-between border rounded-lg p-4 w-full bg-white">
                <div className="flex flex-col items-start">
                  <span className="text-3xl font-extrabold text-[#111928]">
                    1.4k
                  </span>
                  <span className="text-sm text-[#6B7280]">Total Teams</span>
                </div>
                <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                  10%
                  <svg
                    width={15}
                    height={14}
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-0.5"
                  >
                    <path
                      d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                      fill="#0E9F6E"
                      stroke="#0E9F6E"
                    />
                  </svg>
                </span>
              </div>
              <div className="flex items-center justify-between border rounded-lg p-4 w-full bg-white">
                <div className="flex flex-col items-start">
                  <span className="text-3xl font-extrabold text-[#111928]">
                    163.4k
                  </span>
                  <span className="text-sm text-[#6B7280]">Total Members</span>
                </div>
                <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                  10%
                  <svg
                    width={15}
                    height={14}
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-0.5"
                  >
                    <path
                      d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                      fill="#0E9F6E"
                      stroke="#0E9F6E"
                    />
                  </svg>
                </span>
              </div>
              {/* <div className="flex items-center justify-between border rounded-lg p-4 w-full bg-white">
                <div className="flex flex-col items-start">
                  <span className="text-3xl font-extrabold text-[#111928]">
                    163.4k
                  </span>
                  <span className="text-sm text-[#6B7280]">Total Views</span>
                </div>
                <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                  10%
                  <svg
                    width={15}
                    height={14}
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-0.5"
                  >
                    <path
                      d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                      fill="#0E9F6E"
                      stroke="#0E9F6E"
                    />
                  </svg>
                </span>
              </div> */}
              {/* <div className="flex items-center justify-between border rounded-lg p-4 w-full bg-white">
                <div className="flex flex-col items-start">
                  <span className="text-3xl font-extrabold text-[#111928]">
                    808
                  </span>
                  <span className="text-sm text-[#6B7280]">Unique Views</span>
                </div>
                <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                  10%
                  <svg
                    width={15}
                    height={14}
                    viewBox="0 0 15 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="ml-0.5"
                  >
                    <path
                      d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                      fill="#0E9F6E"
                      stroke="#0E9F6E"
                    />
                  </svg>
                </span>
              </div> */}
            </div>
            <div className="mt-6">
              <div className="grid grid-cols-2 gap-x-3">
                <div className="rounded-lg p-4 shadow w-full bg-white">
                  <div className="flex items-center justify-between">
                    <div className="flex flex-col items-start">
                      <span className="text-3xl font-extrabold text-[#111928]">
                        13 weeks
                      </span>
                      <span className="text-md text-[#6B7280]">
                        Average project completion time per team
                      </span>
                    </div>
                    <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                      10%
                      <svg
                        width={15}
                        height={14}
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="ml-0.5"
                      >
                        <path
                          d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                          fill="#0E9F6E"
                          stroke="#0E9F6E"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="flex flex-col divide-y-2 gap-y-3 mt-6">
                    <div className="w-full h-[25rem]">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartOneData} barSize={40}>
                          <Bar
                            dataKey="Number of Weeks"
                            fill="#942A27"
                            background={{ fill: "#E5E7EB" }}
                            radius={8}
                          />
                          <Tooltip cursor={false} />
                          <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="flex items-center justify-between pt-6">
                      <select value="10" className="bg-inherit">
                        <option value="10">Last 7 months</option>
                      </select>
                      <button className="text-[#942A27] flex items-center">
                        Team Performance Report
                        <svg
                          width={21}
                          height={21}
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-1"
                        >
                          <path
                            d="M8.16797 4.71069L14.0013 10.544L8.16797 16.3774"
                            stroke="#942A27"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="rounded-lg p-4 shadow w-full bg-white">
                  <div className="flex items-center justify-between">
                    <div className="flex flex-col items-start">
                      <span className="text-3xl font-extrabold text-[#111928]">
                        80%
                      </span>
                      <span className="text-md text-[#6B7280]">
                        Average Team Workload - Percentage of their capacity
                        being utilized per week
                      </span>
                    </div>
                    <span className="flex items-center text-md text-[#0E9F6E] font-extra-bold">
                      4,6%
                      <svg
                        width={15}
                        height={14}
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="ml-0.5"
                      >
                        <path
                          d="M3.09677 6.43568L6.1996 3.43063L7.04745 2.6095V3.7898V11.9C7.04745 11.9478 7.0669 11.997 7.10699 12.0358C7.14763 12.0752 7.20606 12.1 7.27022 12.1C7.33438 12.1 7.39282 12.0752 7.43345 12.0358C7.47355 11.997 7.493 11.9478 7.493 11.9V3.7898V2.6095L8.34085 3.43063L11.4397 6.43183C11.4806 6.46899 11.5378 6.49191 11.6001 6.49139C11.6635 6.49085 11.7211 6.46611 11.7612 6.4272C11.8009 6.3888 11.8203 6.34026 11.8208 6.29299C11.8212 6.24663 11.8033 6.19887 11.766 6.16036L7.43343 1.96432C7.43341 1.9643 7.43339 1.96428 7.43338 1.96426C7.39274 1.92495 7.33434 1.90015 7.27022 1.90015C7.20611 1.90015 7.1477 1.92495 7.10707 1.96426L3.09677 6.43568ZM3.09677 6.43568C3.09675 6.43569 3.09673 6.43571 3.09671 6.43573M3.09677 6.43568L3.09671 6.43573M3.09671 6.43573C3.05608 6.47505 2.99768 6.49985 2.93356 6.49985M3.09671 6.43573L2.93356 6.49985M2.93356 6.49985C2.86947 6.49985 2.81109 6.47507 2.77046 6.43578L2.93356 6.49985ZM2.77046 6.16421L7.10701 1.96432L2.77035 6.43568C2.73034 6.39686 2.71094 6.34773 2.71094 6.3C2.71094 6.25224 2.73036 6.20308 2.77041 6.16427C2.77042 6.16425 2.77044 6.16423 2.77046 6.16421Z"
                          fill="#0E9F6E"
                          stroke="#0E9F6E"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="flex flex-col divide-y-2 gap-y-3 mt-6">
                    <div className="w-full h-[25rem]">
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartTwoData}>
                          <Bar dataKey="Workload" fill="#942A27" radius={8} />
                          <Tooltip
                            cursor={false}
                            content={({ active, payload, label }) => {
                              console.log(active, payload, label);
                              return (
                                <div className="flex flex-col items-start gap-y-1 py-4 px-3 bg-white border-2">
                                  {label}
                                  <span
                                    className="text-sm font-medium"
                                    style={{
                                      color: payload[0]?.color
                                        ? payload[0]?.color
                                        : "black",
                                    }}
                                  >
                                    {`${payload[0]?.name} : ${payload[0]?.value}%`}
                                  </span>
                                </div>
                              );
                            }}
                          />
                          <XAxis
                            dataKey="name"
                            axisLine={false}
                            tickLine={false}
                            // style={{ display: "none" }}
                          />
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                    <div className="flex items-center justify-between pt-6">
                      <select value="10" className="bg-inherit">
                        <option value="10">Last 7 months</option>
                      </select>
                      <button className="text-[#942A27] flex items-center">
                        Change to Team Workload Report
                        <svg
                          width={21}
                          height={21}
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="ml-1"
                        >
                          <path
                            d="M8.16797 4.71069L14.0013 10.544L8.16797 16.3774"
                            stroke="#942A27"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-6">
            <span className="text-[#6B7280] text-md">Recent Activities</span>
            <AdminTable />
          </div>
        </main>
      </section>
    </DashboardLayout>
  );
};

export default SuperAdmin;
